import { render, staticRenderFns } from "./basic-single-video.vue?vue&type=template&id=ff81466c&scoped=true&"
import script from "./basic-single-video.vue?vue&type=script&lang=js&"
export * from "./basic-single-video.vue?vue&type=script&lang=js&"
import style0 from "./basic-single-video.vue?vue&type=style&index=0&id=ff81466c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff81466c",
  null
  
)

export default component.exports